import Vue from 'vue'
import Router from 'vue-router'
import LexinDictionary from './components/LexinDictionary.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'LexinDictionaryComponent',
      component: LexinDictionary
    },
    {
      path: '/mode=about&ui-lang='+localStorage.getItem('lang'),
      name: 'AboutComponent',
      component: () => import('./components/AboutLexin.vue')
    },
    {
      path:'/mode=about&sub-mode=about-search&ui-lang='+localStorage.getItem('lang'),
      name: 'AboutSearchComponent',
      component: () => import('./components/AboutSearch.vue')
    },
    {
      path:'/mode=about&sub-mode=about-speech&ui-lang='+localStorage.getItem('lang'),
      name: 'AboutSpeechComponent',
      component: () => import('./components/AboutSpeech.vue')
    },
    {
      path: '/mode=about&sub-mode=new-dictionaries&ui-lang='+localStorage.getItem('lang'),
      name: 'DictionaryInprogressComponent',
      component: () => import('./components/DictionaryInProgress.vue')
    },
    {
      path: '/mode=list-printed&ui-lang='+localStorage.getItem('lang'),
      name: 'PrintedDictionariesComponent',
      component: () => import('./components/PrintedDictionaries.vue')
    },
    {
      path: '/mode=about-the-project&ui-lang='+localStorage.getItem('lang'),
      name: 'AboutProjectComponent',
      component: () => import('./components/AboutProject.vue')
    },
    {
      path: '/mode=contact-us&ui-lang='+localStorage.getItem('lang'),
      name: 'ContactUsComponent',
      component: () => import('./components/ContactUs.vue')
    },
      {
          path: '/mode=exam&ui-lang=nbo',
          name: 'DomainListComponent',
          component: () => import('./components/DomainList.vue')
      },
      {
          path: '/mode=exam&ui-lang=nny',
          name: 'DomainListComponent',
          component: () => import('./components/DomainList.vue')
      },
      {
          path: '/mode=exam&ui-lang=eng',
          name: 'DomainListComponent',
          component: () => import('./components/DomainList.vue')
      },
    {
      path: '/mode=help&ui-lang='+localStorage.getItem('lang'),
      name: 'HelpComponent',
      component: () => import('./components/Help.vue')
    },
    {
      path: '/mode=privacystatement&ui-lang='+localStorage.getItem('lang'),
      name: 'PrivacyStatementComponent',
      component: () => import('./components/PrivacyStatement.vue')
    },
    {
      path: '/mode=accessibilitystatement&ui-lang='+localStorage.getItem('lang'),
      name: 'AccessibilityStatementComponent',
      component: () => import('./components/AccessibilityStatement.vue')
    },
    // {
    //   path: '/picture/:id/:wordtext/:wordId/:lang',
    //   name: 'PictureComponent',
    //   component: () => import('./components/Picture.vue')
    // },
    {
      path: '/findwords/:dictionary',
      name: 'FindwordsComponent',
      component: () => import('./components/Findwords.vue'),
      props:true
    },
    {
      path: '*',
      component: () => import('./components/errorpages/404.vue')
    },
  ]
})
